import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';

// Get saved language or default to French
const savedLanguage = localStorage.getItem('language') || 'fr';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr }
        },
        lng: savedLanguage,
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false
        }
    });

// Keep <html lang> honest.
//
// index.html can only declare one language, and the user can switch at runtime.
// When the attribute disagrees with what is on screen, Chrome and Edge decide
// the page is in a foreign language and offer to machine-translate it — which
// is how "Modifier" became "Modificateur" and the Land Rover "Defender" became
// "Défenseur" on a browser profile that had not already dismissed the prompt.
//
// Nothing renders off this, so it is done imperatively rather than through a
// component: a helmet/head component would only cover the routes it wraps.
function syncDocumentLang(lng) {
    if (typeof document === 'undefined') return; // tests / SSR
    document.documentElement.setAttribute('lang', lng || 'fr');
}

syncDocumentLang(i18n.language || savedLanguage);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
